'use strict'

import ReportMaterialsGroup from './ReportMaterialsGroup.js'

export default class ReportMountingsGroup extends ReportMaterialsGroup {
  hasEqualComplexKeys (record1, record2) {
    if (record1.recId) {
      if (record1.recId !== record2.recId) {
        return false
      }
    } else {
      if (record1.toolName !== record2.toolName) {
        return false
      }
      if (record1.sourceTable !== record2.sourceTable) {
        return false
      }
    }
    return true
  }
}
